import React, { useCallback, useEffect, useState } from 'react';
import qs from 'query-string';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import Loader from '../../../../components/Loader/Loader';
import Button from '../../../../components/Button/Button';

import { setCurrentUser } from '../../../../redux/slices/auth';
import { setCurrentLanguage } from '../../../../redux/slices/stories';

import i18n from '../../../../utils/i18n';
import { ROLES } from '../../../../constants';
import * as userService from '../../../../services/users';
import { setLocalStorage } from '../../../../utils/userService';
import { setTokenToAxios, setTokenToStorage } from '../../../../utils/auth';

import Vimeo from '../../../../icons/Vimeo';
import LinkedIn from '../../../../icons/LinkedIn';
import DgLogoIcon from '../../../../icons/DgLogo';
import ArrowDown from '../../../../icons/ArrowDown';
import Instagram from '../../../../icons/Instagram';

import LanguageIcon from '@material-ui/icons/Language';

import './index.scss';

const aboutUsUrl = 'https://www.home.digitaluniverse.no/omoss',
  contactUsUrl = 'https://www.home.digitaluniverse.no/kontakt',
  faqsUrl = 'https://www.home.digitaluniverse.no/faqs',
  instagramUrl = 'https://www.instagram.com/inspiretoaction_today',
  linkedInurl = 'https://www.linkedin.com/company/inspire-to-action',
  vimeoUrl = 'https://vimeo.com/inspiretoaction';

export const LogInFirstStep = ({ setShowSecondScreen }) => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const {
    stories: { currentLang }
  } = useSelector(store => store);

  const { code } = qs.parse(search);

  const [dropdownChoises, setDropdownChoises] = useState([
    { id: 'no', value: 'Norsk', order: 1 },
    { id: 'en', value: 'English', order: 2 }
  ]);
  const [activeChoise, setActiveChoise] = useState(dropdownChoises[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (currentLang && dropdownChoises[0].id !== currentLang && currentLang !== 'nb') {
      const updatedChoises = [
        { ...dropdownChoises[1], order: 1 },
        { ...dropdownChoises[0], order: 2 }
      ];
      const sorted = [...updatedChoises];
      sorted.sort((a, b) => a.order - b.order);
      setDropdownChoises(sorted);
      setActiveChoise(sorted[0]);
    }
    // eslint-disable-next-line
  }, [currentLang]);

  const choose = useCallback(
    choise => {
      setActiveChoise(choise);
      dispatch(setCurrentLanguage(choise.id));
      i18n.changeLanguage(choise.id);
      setLocalStorage('lng', choise.id);
    },
    [dispatch]
  );

  const onDropdownClick = useCallback(() => {
    setIsDropdownOpen(!isDropdownOpen);
  }, [isDropdownOpen]);

  useEffect(() => {
    if (code) {
      try {
        userService.loginFeide({ code }).then(({ user, token, id_token }) => {
          setTokenToAxios(token);
          setTokenToStorage(token);
          setLocalStorage('id_token', id_token);

          dispatch(setCurrentUser(user));
          if (user.role === ROLES.TEACHER) history.push('/teacher');
          else if (user.role === ROLES.STUDENT)
            if (localStorage['redirect']) {
              history.push(`${localStorage['redirect']}`);
              localStorage.removeItem('redirect');
            } else history.push('/student');
          else history.push('/');
        });
      } catch (err) {
        setError(err);
      }
    }
  }, [dispatch, history, code, location]);

  if (!error && code) {
    return <Loader full />;
  }

  if (error) {
    return JSON.stringify(error);
  }

  return (
    <div className="main-container">
      <div className="logo-container">
        <DgLogoIcon />
        <span className="text">Digital Universe</span>
      </div>

      <div className="content-text">
        <h1>
          {t('Join our')}
          <span className="red-span"> {t('Digital Learning')}</span> {t('Adventures')}
        </h1>
        <p>
          {t('Learn through engaging, ')}
          <span className="red-span sub-span">{t('interactive stories!')} </span>
        </p>
      </div>

      <Button className="feide-btn" onClick={() => setShowSecondScreen(true)}>
        {t('Login with Feide')}
      </Button>

      <div className="footer">
        <div className="footer-content">
          <a href={instagramUrl}>
            <Instagram />
          </a>
          <a href={linkedInurl}>
            <LinkedIn />
          </a>
          <a href={vimeoUrl}>
            <Vimeo />
          </a>
        </div>

        <div className="footer-content">
          <a href={aboutUsUrl}>
            <p>{t('About us')}</p>
          </a>
          <a href={contactUsUrl}>
            <p>{t('Contact us')}</p>
          </a>
          <a href={faqsUrl}>
            <p>{t('FAQs')}</p>
          </a>
          <div className="dropdown-container">
            <LanguageIcon style={{ fontSize: '1.3rem', marginLeft: '5px' }} />
            <div className="dropdown-select" onClick={onDropdownClick}>
              <span className="dropdown-selected">{t(activeChoise.value)}</span>
              <ArrowDown
                className={classnames({
                  'arrow-down': true,
                  active: isDropdownOpen
                })}
              />

              <div
                className={classnames({
                  'dropdown-content': true,
                  active: isDropdownOpen
                })}
              >
                {dropdownChoises.map(choise => (
                  <div
                    className={classnames({
                      'dropdown-option': true,
                      active: choise.id === activeChoise.id
                    })}
                    key={choise.id}
                    onClick={() => choose(choise)}
                  >
                    {t(choise.value)}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
